

import React from 'react';
import { Page } from './Blocks';

import RowBuilder from './RowBuilder';

import { DataAdapterProvider } from '../contexts/DataAdapterContext';


import { ThemeProvider } from '../contexts/ThemeContext';











const SplashRenderer = (props) => {
  const {
    contents: { page } = {},
    shootstaPlayerProps,
    isPreview = false,
    replaceVariables,
    brandingColor,
    allowCalendarLinks,
    onButtonClick
  } = props;

  const { container = {}, rows = [] } = page || {};
  const { style = {}, computedStyle = '' } = container || {};

  return (
    <DataAdapterProvider
      shootstaPlayerProps={shootstaPlayerProps}
      isPreview={isPreview}
      replaceVariables={replaceVariables}
      allowCalendarLinks={allowCalendarLinks}
      onButtonClick={onButtonClick}>

      <ThemeProvider primary={brandingColor}>
        <Page
          style={style}
          computedStyle={computedStyle}>

          {rows.map(
            (row) =>
            <RowBuilder
              key={row.uuid}
              isVisible={row.isVisible}
              uuid={row.uuid}
              columns={row.columns}
              container={row.container} />


          )}
        </Page>
      </ThemeProvider>
    </DataAdapterProvider>);

};

export default SplashRenderer;